import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ size = 16, className = "" }) {
  return (
    <BadgeCheck
      data-testid="verified-badge"
      title="Verified BAMS scholar"
      className={`inline-block text-[color:var(--ayur-gold)] ${className}`}
      style={{ width: size, height: size, fill: "var(--ayur-gold)", color: "#FBF9F4" }}
    />
  );
}
